module.exports = __webpack_public_path__ + "img/icon_black_ok.6341504d.png";